module.exports = __webpack_public_path__ + "img/home_welcome2_2.8f180eb4.jpg";